<template>
  <div :class="componentClassName">
    <section id="lp-brand-section" class="t-default-lp-layout__section">
      <div class="t-default-lp-layout__container">
        <o-lp-global-header :nav-list="navList" :handle-nav-button-click="handleNavButtonClick" />
      </div>
    </section>
    <slot></slot>
    <o-lp-global-footer />
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import OLpGlobalHeader from '@/components/organisms/lp-global-header';
import OLpGlobalFooter from '@/components/organisms/lp-global-footer';

export default {
  name: 't-default-lp-layout',
  components: {
    OLpGlobalHeader,
    OLpGlobalFooter,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    helpUrl: {
      type: String,
      default: 'https://support.ntt.com/ccaas/inquiry/search',
    },
    privacyPolicyUrl: {
      type: String,
      default: 'https://www.ntt.com/about-us/hp/privacy.html',
    },
    termsUrl: {
      type: String,
      default: 'https://www.ntt.com/about-us/disclosure/tariff/yakkan.html',
    },
    navList: {
      type: Array,
      default: new Array(0),
    },
    handleNavButtonClick: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-default-lp-layout');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
};
</script>
